export enum SubscriptionPaymentType {
	PIX = "PIX",
	CARD = "CARD",
}
